import Shop from '@/shop';
import FacebookPixel from '@/extensions/facebook/pixel';

function initFacebookExtension() {
  var facebook = Shop.config.get('facebook').facebook || {};

  if (facebook.pixelActive) {
    new FacebookPixel(facebook);
  }
}

document.addEventListener('DOMContentLoaded', initFacebookExtension);
